import * as React from 'react';
import { FC, useRef } from 'react';
import ReactQuill from 'react-quill';
import styled from 'styled-components';

import 'react-quill/dist/quill.snow.css';

const MODULES = {
    toolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['clean'],
    ],
};

const FORMATS = ['bold', 'italic', 'underline', 'list', 'bullet'];

const EditorWrapper = styled.div`
    .ql-toolbar.ql-snow {
        border-color: var(--appLigthGrey);
        border-radius: 4px 4px 0 0;
        padding: var(--spacer-XXS) var(--spacer-XS);
        background: var(--bg-light);
    }

    .ql-container.ql-snow {
        border-color: var(--appLigthGrey);
        border-radius: 0 0 4px 4px;
        font-size: 0.875rem;
    }

    .ql-editor {
        min-height: 80px;
        padding: var(--spacer-XS) var(--spacer-S);
    }

    .ql-editor.ql-blank::before {
        color: var(--text-placeholder);
        font-style: normal;
    }
`;

const Label = styled.label`
    font-size: 0.875rem;
    color: var(--text-body);
    margin-bottom: var(--spacer-XXS);
    display: block;
`;

interface SurveyDescriptionEditorProps {
    label?: string;
    placeholder?: string;
    value: string;
    onChange: (value: string) => void;
}

const SurveyDescriptionEditor: FC<SurveyDescriptionEditorProps> = ({ label, placeholder, value, onChange }) => {
    const quillRef = useRef<ReactQuill>(null);

    const handleChange = (html: string) => {
        const isEmpty = html === '<p><br></p>';
        onChange(isEmpty ? '' : html);
    };

    return (
        <div>
            {label && <Label>{label}</Label>}
            <EditorWrapper>
                <ReactQuill
                    ref={quillRef}
                    theme="snow"
                    value={value}
                    onChange={handleChange}
                    modules={MODULES}
                    formats={FORMATS}
                    placeholder={placeholder}
                />
            </EditorWrapper>
        </div>
    );
};

export default SurveyDescriptionEditor;
